import { Control, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

// local imports
import DateUtil from 'utils/DateUtil'
import { IAvailableParkAreasReq } from 'types/ParkAreaType'
import DatePickerIcon from 'components/ui/DatePickerIcon'
import { DatePickerWrapper, FilterButton, ResetButton } from './styled'

interface IParkAreaFormProps {
  disableResetBtn: boolean
  disableSubmitBtn: boolean
  handleReset: () => void
  control: Control<IAvailableParkAreasReq>
}

export default function ParkAreaFilterForm({
  control,
  handleReset,
  disableResetBtn,
  disableSubmitBtn,
}: IParkAreaFormProps) {
  const { t } = useTranslation()

  return (
    <>
      {/* Reservation Date */}
      <DatePickerWrapper id="parkReservationDateWrapper">
        <Controller
          name="reservationDate"
          control={control}
          render={({ field }) => (
            <DatePickerIcon
              readOnlyInput={false}
              selectOtherMonths
              showOtherMonths
              disabledDays={[]}
              idName="parkAreaReservationDate"
              defaultDate={field.value}
              minDate={DateUtil.getPastDate(0)}
              maxDate={DateUtil.futureMonth()}
              onSelectedDateChange={(e) => field.onChange(e.value as Date)}
              label={t('input-texts.reservation-date')}
              placeholder={t('input-texts.reservation-date')}
            />
          )}
        />
      </DatePickerWrapper>

      <div>
        {/* Action Buttons */}
        <ResetButton
          id="parkAreaResetBtn"
          disabled={disableResetBtn}
          type="button"
          onClick={handleReset}
          label={t('most-used-words.reset')}
          className="p-button-outlined"
        />

        <FilterButton
          id="parkAreaFilterBtn"
          disabled={disableSubmitBtn}
          type="submit"
          label={t('most-used-words.filter')}
        />
      </div>
    </>
  )
}
